import {
  fallbackLanguage,
  supportedLocales,
  type SupportedLocale,
} from '@/i18n/localeConfigs';

export type EmbeddedShellLanguage = 'en' | 'it';

export function normalizeStoredLocale(
  value: string | null | undefined,
): SupportedLocale {
  if (!value) {
    return fallbackLanguage;
  }

  const lower = value.toLowerCase();

  if (lower === 'it' || lower.startsWith('it-')) {
    return 'it-IT';
  }

  if (lower === 'en' || lower.startsWith('en-')) {
    return 'en-US';
  }

  if ((supportedLocales as readonly string[]).includes(value)) {
    return value as SupportedLocale;
  }

  return fallbackLanguage;
}

export function toEmbeddedShellLanguage(
  locale: SupportedLocale,
): EmbeddedShellLanguage {
  return locale === 'it-IT' ? 'it' : 'en';
}
